import { Text } from "@chakra-ui/react";
export default function Emphasis(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <Text as="b" color="brand.offBlue">{children}</Text>
  )
}